export const listCopyEn = {
    published: "Published",
    draft: "Draft",
    name: "Name",
    role: "Role",
    organisation: "Organisation",
    email: "Email",
    dateOfBirth: "Date of Birth",
    labels: "Labels",
    status: "Status",
    actions: "Actions",
};
